import { isNil } from "es-toolkit";

export function run<T>(fn: () => NoInfer<T>): T {
    return fn();
}

export function runWhen<D, T>(data: D | undefined, fn: (data: D) => NoInfer<T>): T | undefined {
    if (isNil(data)) return undefined;
    return fn(data);
}

export function runWithDefault<D, T>(fallback: NoInfer<T>, data: D | undefined, fn: (data: D) => NoInfer<T>): T {
    if (isNil(data)) return fallback;
    return fn(data);
}
